import { FormFM1ClientType } from 'api/types/params';
import { ContentHeader, GridFields } from 'components';
import { formatPrice, parsePrice } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { isFloat, Stack, Typography } from 'libs/ui';
import { FileExtension } from 'types/file';

import {
  Field,
  FormFM1Currency,
  MAX_FILES,
  MAX_FLOATING_POINTS,
  MAX_RATE,
  MIN_RATE,
} from '../../forms/formFM1Form';

import { FilesUpload } from './FilesUpload';

const checkNumber = (v?: string) => isFloat(v, MAX_FLOATING_POINTS);
const format = (v?: number) => formatPrice(v, false, MAX_FLOATING_POINTS);
const parse = (v?: string) => parsePrice(v, MAX_FLOATING_POINTS);

export const FormContent = () => {
  const { t } = useTranslation();

  return (
    <Stack spacing={24}>
      <Stack spacing={8}>
        <ContentHeader header={t('formFM1.title')} />
        <Typography>{t('formFM1.subtitle')}</Typography>
      </Stack>
      <GridFields>
        <Field.Autocomplete
          multiple
          showRequiredMark
          label={t('formFM1.client.label')}
          name="clients"
          optionLabelKey="label"
          options={Object.values(FormFM1ClientType).map((v) => ({
            label: t(`formFM1.client.types.${v}`),
            value: v,
          }))}
          optionValueKey="value"
          placeholder={t('formFM1.client.placeholder')}
          variant="select"
        />
        <Field.Number
          fullWidth
          showRequiredMark
          label={t('formFM1.thresholdValue.label')}
          maxLength={9}
          name="thresholdValue"
          placeholder={t('formFM1.thresholdValue.placeholder')}
        />
        <Field.Autocomplete
          fullWidth
          showRequiredMark
          label={t('formFM1.currency.label')}
          name="currency"
          optionLabelKey="label"
          options={Object.values(FormFM1Currency).map((v) => ({
            label: v,
            value: v,
          }))}
          optionValueKey="value"
          placeholder={t('formFM1.currency.placeholder')}
        />
        <Field.Price
          fullWidth
          showRequiredMark
          checkNumber={checkNumber}
          format={format}
          label={t('formFM1.usdKzt.label')}
          maxNumber={MAX_RATE}
          minNumber={MIN_RATE}
          name="usdKzt"
          parse={parse}
          placeholder={t('formFM1.usdKzt.placeholder')}
        />
        <Field.Price
          fullWidth
          showRequiredMark
          checkNumber={checkNumber}
          format={format}
          label={t('formFM1.cnyKzt.label')}
          maxNumber={MAX_RATE}
          minNumber={MIN_RATE}
          name="cnyKzt"
          parse={parse}
          placeholder={t('formFM1.cnyKzt.placeholder')}
        />
        <Field.Price
          fullWidth
          showRequiredMark
          checkNumber={checkNumber}
          format={format}
          label={t('formFM1.eurKzt.label')}
          maxNumber={MAX_RATE}
          minNumber={MIN_RATE}
          name="eurKzt"
          parse={parse}
          placeholder={t('formFM1.eurKzt.placeholder')}
        />
        <Field.Price
          fullWidth
          showRequiredMark
          checkNumber={checkNumber}
          format={format}
          label={t('formFM1.rubKzt.label')}
          maxNumber={MAX_RATE}
          minNumber={MIN_RATE}
          name="rubKzt"
          parse={parse}
          placeholder={t('formFM1.rubKzt.placeholder')}
        />
        <Field.Price
          fullWidth
          showRequiredMark
          checkNumber={checkNumber}
          format={format}
          label={t('formFM1.aedKzt.label')}
          maxNumber={MAX_RATE}
          minNumber={MIN_RATE}
          name="aedKzt"
          parse={parse}
          placeholder={t('formFM1.aedKzt.placeholder')}
        />
      </GridFields>
      <FilesUpload
        fileExtensions={[FileExtension.csv]}
        maxFiles={MAX_FILES}
        name="files"
        title={t('formFM1.documentTitle')}
      />
    </Stack>
  );
};
